/**
 * Product card image slider: smooth scroll, dots, wheel, drag. Works in Product recommendations (dynamic content).
 */
(function () {
  var DURATION = 350;
  var INITED = 'data-pcard-slider-inited';

  function getActiveIndex(track) {
    if (!track || !track.children.length) return 0;
    var w = track.offsetWidth;
    var idx = Math.round(track.scrollLeft / w);
    return Math.min(idx, track.children.length - 1);
  }

  function setActiveDot(container, index) {
    var dots = container.querySelectorAll('.m-product-card__media-slider-dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('m:active', i === index);
    });
  }

  function smoothScrollTo(track, targetLeft) {
    var start = track.scrollLeft;
    var dist = targetLeft - start;
    if (dist === 0) return;
    var startTime = null;
    function step(t) {
      if (startTime === null) startTime = t;
      var elapsed = t - startTime;
      var progress = Math.min(elapsed / DURATION, 1);
      progress = 1 - Math.pow(1 - progress, 2);
      track.scrollLeft = start + dist * progress;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function onDotClick(e) {
    var dot = e.target.closest('.m-product-card__media-slider-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    var container = dot.closest('[data-product-card-slider]');
    if (!container) return;
    var track = container.querySelector('.m-product-card__media-slider-track');
    if (!track) return;
    var index = parseInt(dot.getAttribute('data-dot-index'), 10);
    if (isNaN(index) || index < 0) return;
    var slideWidth = track.offsetWidth;
    var targetLeft = slideWidth * index;
    smoothScrollTo(track, targetLeft);
    setActiveDot(container, index);
  }

  function initSlider(container) {
    if (container.getAttribute(INITED) === 'true') return;
    container.setAttribute(INITED, 'true');

    var track = container.querySelector('.m-product-card__media-slider-track');
    if (!track) return;
    var slides = track.querySelectorAll('.m-product-card__media-slider-slide');
    var multi = slides.length > 1;

    if (multi) {
      track.addEventListener('scroll', function () {
        setActiveDot(container, getActiveIndex(track));
      }, { passive: true });

      var isDown = false, startX, scrollStart, hasDragged = false;
      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        scrollStart = track.scrollLeft;
        track.style.scrollSnapType = 'none';
      });
      track.addEventListener('mouseleave', function () {
        isDown = false;
        track.style.scrollSnapType = '';
      });
      track.addEventListener('mouseup', function () {
        isDown = false;
        track.style.scrollSnapType = '';
      });
      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var walk = startX - e.pageX;
        if (Math.abs(walk) > 5) hasDragged = true;
        e.preventDefault();
        track.scrollLeft = scrollStart + walk;
      });

      track.addEventListener('click', function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
  }

  function init() {
    document.querySelectorAll('[data-product-card-slider]').forEach(initSlider);
  }

  document.addEventListener('click', onDotClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  var observer = new MutationObserver(function (mutations) {
    var run = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute && node.hasAttribute('data-product-card-slider')) run = true;
        else if (node.querySelector && node.querySelector('[data-product-card-slider]')) run = true;
        if (run) break;
      }
      if (run) break;
    }
    if (run) init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
